import { render, staticRenderFns } from "./go-back-btn.vue?vue&type=template&id=e37005d2&"
import script from "./go-back-btn.vue?vue&type=script&lang=js&"
export * from "./go-back-btn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports